import { getConfig } from "../../../../../../../hooks/use-config";
import { getLabel } from "../../../../../../../hooks/use-labels";

const ContactSupport = ({ outline }) => {
  const onClick = () => {
    const supportNumber = getConfig("whatsappSupport");
    window.open(`https://wa.me/${supportNumber}`);
  };

  return (
    <button
      type="button"
      className={`ord-btn ${outline ? "ord-btn-outline" : "ord-btn-primary"}`}
      onClick={onClick}
    >
      {getLabel("contactSupportLabel")}
    </button>
  );
};

export default ContactSupport;
